import { Vue, Component, Prop } from 'vue-property-decorator'
import ProductSlides from '~/components/block/ProductSlides'
import ProductSmall from '~/components/element/ProductSmall'
import Product from '~/types/api/Product'

@Component
export default class ProductListSmall extends Vue {
  @Prop({ type: Array, default: () => ([]) })
  readonly products!: Product[]

  get desktopProducts () {
    if (this.products.length > 3) {
      return this.products.slice(0, 3)
    }
    return this.products
  }

  renderDesktop () {
    return (
      <div class="product-list-small__desktop">
        <div class="product-list-small__desktop-row">
          {this.desktopProducts.map(e => (
            <div key={e.id} class="product-list-small__desktop-col">
              <ProductSmall props={{ product: e }} />
            </div>
          ))}
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="product-list-small">
        <div class="product-list-small__desktop">
          {this.renderDesktop()}
        </div>
        <div class="product-list-small__mobile">
          <ProductSlides props={{ products: this.products, isShowHead: false }} />
        </div>
      </div>
    )
  }
}
